// extracted by mini-css-extract-plugin
export default {"modalHeader":"home_modalHeader__hpjGM","info":"home_info__CHhBv","button":"home_button__uGtKC"};